export default __webpack_public_path__ + "static/media/78.812e2423.jpg";